import { translations } from '../i18n';
import { getExperienceById } from '../services/experienceID';
import { useData } from '../stores/data';

type TrackEventProps = {
  event: string;
  event_name: string;
  event_detail?: string;
};

export const useTrackEvent = () => {
  const { experienceId, gtin, data } = useData();
  const translation = translations.en.translation as { [key: string]: string };
  const cfg = experienceId ? getExperienceById(experienceId) : null;

  const trackEvent = (props: TrackEventProps) => {
    const trackingData = {
      ...props,
      brand_name: cfg?.brand_name,
      service_name: 'EcoBeautyScore',
      service_version: 1.0,
      service_category: cfg?.module_type === 'score_only' ? 'ebsMode' : 'fullMode',
      product_gtin: gtin,
      product_ebs_category: data?.EBS?.EBSCategory ? translation[data.EBS.EBSCategory] : undefined,
      product_ebs_score: data?.EBS?.EBSFootprintScore,
      product_info: data?.EBS?.EBSFootprintScore,
    };

    // Push inside the experience
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(trackingData);

    try {
      // Dispatch custom event to parent
      const customEvent = new CustomEvent('ebsTracking', {
        detail: trackingData,
        bubbles: true,
        composed: true,
        cancelable: true,
      });

      const dispatched = window.dispatchEvent(customEvent);

      if (dispatched) {
        console.log('[EBS Tracking] Event dispatched successfully:', {
          event: trackingData.event,
          event_name: trackingData.event_name,
        });
      } else {
        console.warn('[EBS Tracking] Event dispatch was prevented');
      }
    } catch (error) {
      console.error('[EBS Tracking] Error dispatching event:', error);
    }
  };

  return trackEvent;
};
